const normalizeTenantSlug = (tenant) => {
  const rawValue = String(
    tenant?.slug
    || tenant?.code
    || tenant?.codigo
    || tenant?.tenantCode
    || tenant?.domain
    || tenant
    || 'default',
  )
    .trim()
    .toLowerCase();

  if (!rawValue) return 'default';
  if (rawValue.includes('.')) {
    const [firstSegment] = rawValue.split('.');
    return firstSegment || 'default';
  }
  return rawValue;
};

export function getTenantAssetCandidates(tenant, assetName) {
  const tenantSlug = normalizeTenantSlug(tenant);
  const safeAssetName = String(assetName || '').trim().replace(/^\/+/, '');
  if (!safeAssetName) return [];

  return [
    `/tenants/${tenantSlug}/${safeAssetName}`,
    `/tenants/${tenantSlug}/branding/${safeAssetName}`,
  ];
}

export function getTenantLogoCandidates(tenant) {
  return [
    ...getTenantAssetCandidates(tenant, 'logo.png'),
    ...getTenantAssetCandidates(tenant, 'logo.svg'),
    ...getTenantAssetCandidates(tenant, 'logo.jpg'),
    ...getTenantAssetCandidates(tenant, 'logo.jpeg'),
  ];
}
